import moment from 'moment';
import { dateFormatter, datetimeFormatter } from 'utils';

/**
 * Create a new cashbox object
 */
export function cashbox(props, page = null) {
  let scheduled_date = moment(props.scheduled_date).isValid()? dateFormatter(moment.utc(props.scheduled_date, 'YYYY-MM-DD').local()) : 'Not Specified';
  let from_date = moment(props.from_date).isValid()? dateFormatter(moment.utc(props.from_date, 'YYYY-MM-DD').local()) : 'Not Specified';
  let to_date = moment(props.to_date).isValid()? dateFormatter(moment.utc(props.to_date, 'YYYY-MM-DD').local()) : 'Not Specified';
  const filterZeroAndNullValues = (details, valueKey) => {
    return details
      .filter(detail => detail[valueKey] !== null && parseFloat(detail[valueKey]) !== 0)
      .map(detail => `${
        detail.collection_type ? 
        detail.collection_type.label + ":": 
        (valueKey == 'value' ? '' : "Cash:")} ${detail[valueKey]} ${detail.currency.code}`)
      .join("\n and \n");
  };

  const formatPreparedValues = (data, valueKey) => {
    if (!data || !Array.isArray(data)) return 'N/A';
    return data
      .filter(item => item[valueKey] !== null && parseFloat(item[valueKey]) !== 0)
      .map(item => `${item.type}: ${item[valueKey]} ${item.currency}`)
      .join("\n and \n");
  };

  const formatCurrencyTotalsSettlement = (currencyTotals) => {
    if (!currencyTotals || currencyTotals.length === 0) return null;

    const formatted = currencyTotals
      .filter(ct => ct.settlement_amount !== null && parseFloat(ct.settlement_amount || 0) !== 0)
      .map(ct => {
        const currency = ct.currency_code || 'USD';
        const amount = parseFloat(ct.settlement_amount);
        const label = ct.collection_type === 'check' ? 'Check: ' : '';
        return `${label}${amount.toLocaleString()} ${currency}`;
      });

    return formatted.length > 0 ? formatted.join('\n and \n') : null;
  };

  const expected_amount = formatCurrencyTotalsSettlement(props.currency_totals) ||
    (props.preparedData?.data ?
      formatPreparedValues(props.preparedData.data, 'grandTotal') :
      (props.cashbox_details.length > 0 ? filterZeroAndNullValues(props.cashbox_details, 'expected_amount') || 'N/A' : 'N/A'));

  const total_orders_delivery_charge = props.preparedData?.data ? 
    formatPreparedValues(props.preparedData.data, 'totalWKFees') :
    (props.cashbox_details.length > 0 ? filterZeroAndNullValues(props.cashbox_details, 'total_orders_delivery_charge') || 'N/A' : 'N/A');

  const total_orders_collection = props.preparedData?.data ? 
    formatPreparedValues(props.preparedData.data, 'totalCollection') :
    (props.cashbox_details.length > 0 ? filterZeroAndNullValues(props.cashbox_details, 'total_orders_collection_amount') || 'N/A' : 'N/A');

  const formatBalances = (balances) => {
    if (!balances || balances.length === 0) return 'N/A';
    
    const formatted = balances
      .filter(balance => {
        const amount = parseFloat(balance.amount || 0);
        return amount !== 0 && balance.amount !== null;
      })
      .map(balance => {
        const currency = balance.currency_code || balance.currency?.code || 'USD';
        const amount = parseFloat(balance.amount || 0);
        return `${amount.toLocaleString()} ${currency}`;
      });
    
    return formatted.length > 0 ? formatted.join('\n and \n') : 'N/A';
  };

  // Use currency_totals if available (for Ready To Deliver status), otherwise use balances
  const formatCurrencyTotalsBalance = (currencyTotals) => {
    if (!currencyTotals || currencyTotals.length === 0) return null;
    
    const formatted = currencyTotals
      .filter(ct => {
        const balance = parseFloat(ct.balance || 0);
        const collectionType = ct.collection_type;
        // Skip check if balance is 0
        if (collectionType === 'check' && balance === 0) {
          return false;
        }
        return balance !== 0 && ct.balance !== null;
      })
      .map(ct => {
        const currency = ct.currency_code || 'USD';
        const balance = parseFloat(ct.balance || 0);
        const collectionType = ct.collection_type;
        const label = collectionType === 'check' ? 'Check: ' : '';
        return `${label}${balance.toLocaleString()} ${currency}`;
      });
    
    return formatted.length > 0 ? formatted.join('\n and \n') : null;
  };

  const cashbox_table_balance = formatCurrencyTotalsBalance(props.currency_totals) || formatBalances(props.balances);
  return {
    page_index: page,
    id: props.id,
    status: props.status? props.status : "Pending",
    customer: props.customer,
    client_name: props.customer.name,
    account_number:  props.customer.accounting_ref ? props.customer.accounting_ref : 'N/A',
    email: props.cashbox_setting.email,
    contact_name: props.cashbox_setting.contact_name,
    scheduled_date: scheduled_date ? scheduled_date : null,
    from_date: from_date ? from_date : null,
    to_date: to_date ? to_date : [],
    customer_location: props.location,
    all_customer_locations : props.all_customer_locations ? props.all_customer_locations : [],
    customer_location_label: props.location? `${props.customer.name} - ${props.location.type_label ? props.location.type_label + " - ": "" }  ${props.location.area.name}` : null,
    office: props.office,
    wakilni_branch : props.office? props.office.name : null,
    notes: props.notes ? props.notes: 'N/A',
    office_location : props.office_location? props.office_location : null,
    office_location_label:  props.office? props.office.name : null,
    customer_default_currency: props.customer_default_currency,
    customer_currency_rates: props.customer_currency_rates,
    status_code: props.status_code,
    cashbox_details: props.cashbox_details,
    expected_amount: expected_amount,
    official_invoice: props.cashbox_setting.official_invoice ? 'Yes' : 'No',
    total_orders_delivery_charge: total_orders_delivery_charge,
    total_orders_collection: total_orders_collection,
    balances: props.balances,
    cashbox_table_balance: cashbox_table_balance,
    currency_totals: props.currency_totals || [],
    deducted_invoices: props.deducted_invoices || [],
    is_creating_order : props.is_creating_order,
    is_cashbox_cancelling : props.is_cashbox_cancelling,
    preparedData: props.preparedData,
    cashbox_setting: props.cashbox_setting
  };
}